module.exports = __webpack_public_path__ + "img/charging-session-infograph-mobile-fr@2x.5344b173.webp";